import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DepartmentSchema, type ArchiveDepartmentInput, type Department } from '@magimp/shared';
import { useApiClient } from '../api/context.js';

export function useArchiveDepartment(id: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<Department, unknown, ArchiveDepartmentInput>({
    mutationFn: (input) =>
      client.patch<Department>(`/departments/${id}/archive`, input, {}, DepartmentSchema),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['departments', 'list'] });
      qc.invalidateQueries({ queryKey: ['department', id] });
    },
  });
}
